var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"b9dc1d10452fc619a96606331d5a588f2bb81a0b"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN || '';
const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT || '';

Sentry.init({
  dsn: SENTRY_DSN,
  sampleRate: 0.3,
  tracesSampleRate: 0.05,
  environment: ENVIRONMENT,
  enabled: ENVIRONMENT !== 'development',
  ignoreErrors: [
    'Failed to fetch',
    'cancelled',
    'NetworkError',
    'Could not establish connection',
    'Receiving end does not exist',
    'NS_ERROR_FAILURE',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Script error.',
    'Non-Error promise rejection captured',
    'Timeout',
    'AbortError',
  ],

  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /google-analytics\.com/i,
    /googletagmanager\.com/i,
    /recaptcha/i,
  ],

  beforeSend(event) {
    if (!event.message && !event.exception) return null;
    if (event.message === 'No error message' || event.message === 'Timeout') return null;

    if (event.exception?.values?.[0]?.type === 'NS_ERROR_FAILURE' || event.message?.includes('NS_ERROR')) {
      return null;
    }

    if (event.exception?.values?.[0]?.type === 'TypeError') {
      const value = event.exception.values[0].value || '';
      const frames = event.exception.values[0].stacktrace?.frames || [];

      const isProjectCode = frames.some(
        (frame) =>
          frame.filename?.includes('makeship') ||
          frame.filename?.includes('/_next/') ||
          frame.filename?.includes('/src/') ||
          frame.filename?.includes('/chunks/pages/'),
      );

      const isThirdParty = frames.some(
        (frame) =>
          frame.filename?.includes('extension') ||
          frame.filename?.includes('chrome://') ||
          frame.filename?.includes('moz-extension://') ||
          frame.filename?.includes('google-analytics') ||
          frame.filename?.includes('gtag') ||
          !frame.filename,
      );

      if (isThirdParty && !isProjectCode) {
        const noisePatterns = ['undefined is not an object', 'Cannot read propert', 'null is not an object'];

        if (noisePatterns.some((pattern) => value.includes(pattern))) {
          return null;
        }
      }

      if (isProjectCode) {
        return event;
      }
    }

    const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
    if (frames.length === 0) {
      const suspiciousMessages = ['Script error', 'No error message'];

      if (suspiciousMessages.some((msg) => event.message?.toLowerCase().includes(msg.toLowerCase()))) {
        return null;
      }
    }

    return event;
  },
});
